  import React, { useState, useEffect } from 'react';
  import './wallet.css';
  import { getToken } from '../../function/token';
  import domain from '../../../reusecomponent/domain';
  import Preloader from '../preloader';
  import { PERMISSIONS } from '../../constants/permissions';

  const mockWalletHistory = [
  ];

  export default function WalletHistory() {
    const [walletHistory, setWalletHistory] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
      fetchWalletHistory();
    }, []);

    const fetchWalletHistory = async () => {
      try {
        setLoading(true);
        const access_token = getToken();
        const myHeaders = new Headers();
        myHeaders.append('Authorization', `Bearer ${access_token}`);
        myHeaders.append('Content-Type', 'application/json');

        const requestOptions = {
          method: 'GET',
          headers: myHeaders,
          redirect: 'follow',
        };

        const response = await fetch(`${domain()}/wallettopup`, requestOptions);
        const result = await response.json();
              
        if (result.status && result.data) {
          try {
            // Decode the base64 data
            const decodedData = JSON.parse(atob(result.data));            
            if (decodedData.data && Array.isArray(decodedData.data)) {
              // Transform the data to match our table structure
              const transformedData = decodedData.data.map((item, index) => ({
                id: index + 1,
                opening: parseFloat(item.opening_balance) || 0,
                closing: parseFloat(item.closing_balance) || 0,
                amount: parseFloat(item.amount) || 0,
                payment_description: item.payment_description || 'Wallet Topup',
                payment_type: item.payment_type || 'Credit',
                created_at: item.created_at || '',
                orderId: `TXN-${index + 1}` // Generate a transaction ID since it's not in the response
              }));
              
              setWalletHistory(transformedData);
            } else {
              console.log('No valid data array found, using mock data');
              setWalletHistory(mockWalletHistory);
            }
          } catch (decodeError) {
            console.error('Failed to decode base64 data:', decodeError);
            setError('Failed to decode wallet history data');
            setWalletHistory(mockWalletHistory);
          }
        } else {
          console.error('Wallet History API Error:', result.message);
          setError(result.message || 'Failed to fetch wallet history');
          setWalletHistory(mockWalletHistory);
        }
      } catch (error) {
        console.error('Wallet History Fetch Error:', error);
        setError('Network error occurred');
        setWalletHistory(mockWalletHistory);
      } finally {
        setLoading(false);
      }
    };

    // Check if user has permission to view wallet topup history
    // if (!hasPermission(PERMISSIONS.BILLING_WALLET_TOPUP_VIEW)) {
    //   return (
    //     <div className="container-fluid">
    //       <div className="row justify-content-center">
    //         <div className="col-12 text-center mt-5">
    //           <h3>Access Denied</h3>
    //           <p>You don't have permission to view wallet history.</p>
    //         </div>
    //       </div>
    //     </div>
    //   );
    // }

    if (loading) {
      return (
        <div className="wallet-history-container">
          <h2>Wallet History</h2>
          <div className="wallet-loading-container">
            <Preloader action={loading} />
            <p className="loading-text">Loading wallet history...</p>
          </div>
        </div>
      );
    }

    // Ensure walletHistory is always an array
    const displayData = Array.isArray(walletHistory) ? walletHistory : mockWalletHistory;

    return (
      <div className="container-fluid dashboard-main m-0 py-0" style={{minHeight: 'calc(100vh - 150px)', background: '#f7f8fa'}}>
        <div className="wallet-history-container w-100 card border-0 shadow-sm p-4 h-100" style={{ borderRadius: '20px', border: '1px solid #e2e8f0', boxShadow: '0 4px 20px rgba(0, 0, 0, 0.05)', background: '#fff' }}>
          <h2 style={{ fontFamily: '"Outfit", sans-serif', fontWeight: 'bold', fontSize: '24px', marginBottom: '20px' }}>Wallet History</h2>
          {error && (
            <div style={{ color: 'red', marginBottom: '10px', padding: '10px', backgroundColor: '#ffe6e6', borderRadius: '5px' }}>
              Error: {error}
            </div>
          )}
          <div className="table-responsive" style={{ borderRadius: '12px' }}>
            <table className="table payment-history-table align-middle">
            <thead>
              <tr>
                <th>Sl No</th>
                <th>Opening Balance</th>
                <th>Amount</th>
                <th>Closing Balance</th>
                <th>Type</th>
                <th>Description</th>
                <th>Date</th>
              </tr>
            </thead>
            <tbody>
              {displayData.map((entry, idx) => (
                <tr key={entry.id || idx}>
                  <td>{idx + 1}</td>
                  <td>₹{entry.opening?.toLocaleString() || '0'}</td>
                  <td className={entry.payment_type  === 'Credit' ? 'credit' : 'debit'}>
                    {entry.payment_type  === 'Debit' ? (
                      <span>- ₹{Math.abs(entry.amount).toLocaleString()}</span>
                    ) : (
                      <span>+ ₹{entry.amount?.toLocaleString() || '0'}</span>
                    )}
                  </td>
                  <td>₹{entry.closing?.toLocaleString() || '0'}</td>
                  <td>
                    <span style={{ 
                      color: entry.payment_type === 'Credit' ? '#21bf06' : '#dc3545',
                      fontWeight: 'bold'
                    }}>
                      {entry.payment_type || 'Credit'}
                    </span>
                  </td>
                  <td>{entry.payment_description || ''}</td>
                  <td>{entry.created_at || 'N/A'}</td>
                </tr>
              ))}
              {
                displayData.length === 0 && (
                  <tr>
                    <td colSpan="7" style={{ textAlign: 'center', padding: '20px' }}>
                      No wallet history available.
                    </td>
                  </tr>
                )
              }
            </tbody>
            </table>
          </div>
        </div>
      </div>
    );
  } 